import { registerModuleCatalog } from '@/shared/i18n/i18n';

// Catálogo do módulo (U33), carregado com a casca (`eager`): o título do manifesto aparece no menu, no
// ⌘K e no breadcrumb antes de a tela abrir. A porta (`public.ts`) importa este arquivo pelo efeito.
registerModuleCatalog('billing-product', (locale) => import(`./locales/${locale}.po`), { eager: true });
